import { render } from "./Markdown.vue?vue&type=template&id=7ac90e4b&scoped=true"
import script from "./Markdown.vue?vue&type=script&lang=ts"
export * from "./Markdown.vue?vue&type=script&lang=ts"

import "./Markdown.vue?vue&type=style&index=0&id=7ac90e4b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-7ac90e4b"

export default script